import { createStaticDataSource, IRuntimeConfig, RuntimeDataSources, setDataSource } from './configuration';

export function initializeRuntimeStatic(staticData: IRuntimeConfig): void {
  const ds = createStaticDataSource(staticData);
  setDataSource(RuntimeDataSources.Static, ds);
}
